import classNames from 'classnames';
import StarFilled from 'public/icons/icn-star-rating.svg';
import StarEmpty from 'public/icons/icn-star-rating-empty.svg';
import { useState } from 'react';
import { palette } from 'themes/default';

type RatingStarsProps = {
  rating: number;
  size?: number;
  color?: string;
  onRate?: (rating: number) => void;
};

const RatingStars = ({ rating, size, color, onRate }: RatingStarsProps) => {
  const [hover, setHover] = useState(0);
  const displayRating = hover || rating;
  const filledColor = color ?? palette.colorGray100;
  const emptyColor = color ?? (rating ? palette.colorGray100 : palette.colorGray3);
  const sizeStyle = size ? { width: size, height: size } : undefined;
  const interactive = !!onRate;

  return (
    <div
      className={classNames('rating-stars-container', { 'rating-stars-container--interactive': interactive })}
      style={sizeStyle && { height: size }}
    >
      {Array.from({ length: 5 }, (_, i) => {
        const starNumber = i + 1;
        const filled = starNumber <= displayRating;
        const StarComponent = filled ? StarFilled : StarEmpty;

        return (
          <StarComponent
            key={i}
            className="rating-stars-star"
            style={{ color: filled ? filledColor : emptyColor, ...sizeStyle }}
            onClick={interactive ? () => onRate(starNumber) : undefined}
            onMouseEnter={interactive ? () => setHover(starNumber) : undefined}
            onMouseLeave={interactive ? () => setHover(0) : undefined}
          />
        );
      })}
    </div>
  );
};

export default RatingStars;
